"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsFieldTypes = void 0;
var CmsFieldTypes;
(function (CmsFieldTypes) {
    CmsFieldTypes["TEXT"] = "Text";
    CmsFieldTypes["WYSIWYG"] = "Wysiwyg";
    CmsFieldTypes["DATE"] = "Date";
    CmsFieldTypes["DOCUMENT"] = "Document";
    CmsFieldTypes["IMAGE"] = "Src";
    CmsFieldTypes["HREF"] = "Href";
    CmsFieldTypes["WIDGET"] = "Widget";
})(CmsFieldTypes = exports.CmsFieldTypes || (exports.CmsFieldTypes = {}));
